export default "__VITE_ASSET__FgeZCQvG__"